import instance from '../_base'
import { formatUserActivitiesResponse } from '../util/format-data'

const getUserActivities = async ({ key, id }) => {
  const params = [key ? `key=${key}&` : '', id ? `currentPersonId=${id}&` : '']
    .join('')
    .slice(0, -1)
  const url = params ? `/useractivities?${params}` : '/useractivities'

  try {
    const { data } = await instance.get(url)
    const payload = {
      context: data.context,
      data: formatUserActivitiesResponse(data),
    }
    return payload
  } catch (error) {
    console.log(error)
    return await Promise.reject(error)
  }
}

export default {
  getUserActivities,
}
